import issuesRoutes from '@/modules/issues/issues.routes';

export default {
  path: '/p/:projectId',
  name: 'project-parent',
  component: () => import(/* webpackChunkName: "project-parent" */ './ProjectPage.vue'),
  redirect: {
    name: 'project-view',
  },
  meta: {},
  children: [
    {
      path: 'view',
      name: 'project-view',
      component: () => import(/* webpackChunkName: "project-view" */ './ProjectInfoPage.vue'),
      meta: {},
    },
    {
      path: 'accounts',
      name: 'project-accounts',
      component: () => import(/* webpackChunkName: "project-accounts" */ './ProjectAccountsPage.vue'),
      meta: {},
    },
    {
      path: 'expenses',
      name: 'project-expenses',
      component: () => import(/* webpackChunkName: "project-expenses" */ '@/views/EmptyPage.vue'),
      meta: {},
      redirect: {
        name: 'project-view',
      },
    },
    {
      path: 'timesheets',
      name: 'project-timesheets',
      component: () => import(/* webpackChunkName: "project-timesheets" */ '@/views/EmptyPage.vue'),
      meta: {},
      redirect: {
        name: 'project-view',
      },
    },
    {
      ...issuesRoutes,
    },
    {
      path: '*',
      redirect: {
        name: 'project-view',
      },
    },
  ],
};
